import styled from 'styled-components';

import { OtherVertIcon } from '@genially/icons';

export const Wrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
});

export const StyledOtherVertIcon = styled(OtherVertIcon)(
  ({ theme: { color, transition } }) => ({
    color: color.content.secondary.default(),
    transition: transition.standard('color'),
  }),
);

export const ButtonWrapper = styled.div(({ theme: { color, size } }) => ({
  cursor: 'pointer',
  padding: size.units(0.5),

  '&:focus-visible': {
    outline: `2px solid ${color.border.accent.default()}`,
  },

  '&:hover': {
    [StyledOtherVertIcon]: {
      color: color.content.secondary.hover(),
    },
  },
}));

export const ListWrapper = styled.div({
  position: 'relative',
});
